export default __webpack_public_path__ + "assets/alert-circle-stroke-component.81058ae8.svg";